import React, {Component, forwardRef} from "react";
import styles from "./FJWatermarkCommonView.module.less";
import FJSliderInput from "../../../common/component/slider/FJSliderInput";
import FJLocalStore from "../../../store/FJLocalStore";
import classNames from "classnames";
import InlineSVG from "react-inlinesvg";
import PositionIcon from "../../../icon/position.svg";
import FJActionConstant from "../../../constant/FJActionConstant";
import FJCoreConstant from "../../../core/constant/FJCoreConstant";

function PositionBtnItem(props) {
  const {onClick, type, active, className} = props;
  return (
    <div className={classNames(styles.btn, className, {[styles.active]: active})}
         onClick={() => {
           onClick(type)
         }}>
      <InlineSVG src={PositionIcon}/>
    </div>
  );
}

function PositionBtn(props) {
  const {positionChange, watermarkPosition} = props;
  const {LEFT_TOP, RIGHT_TOP, RIGHT_BOTTOM, LEFT_BOTTOM} = FJCoreConstant;
  const {left_top, right_top, right_bottom, left_bottom} = styles;
  const data = [
    {type: LEFT_TOP, className: left_top},
    {type: RIGHT_TOP, className: right_top},
    {type: LEFT_BOTTOM, className: left_bottom},
    {type: RIGHT_BOTTOM, className: right_bottom},
  ];
  return (
    <div className={styles.position_btn_list}>
      {
        data.map(data => {
          let {type, className} = data;
          return (
            <PositionBtnItem onClick={positionChange}
                             key={type}
                             className={className}
                             type={type}
                             active={watermarkPosition === type}/>
          );
        })
      }
    </div>
  )
}

const SliderInput = forwardRef((props,ref) => {
  const {onCallback, name} = props;
  return (
    <div className={styles.slider_input_box}>
      <FJSliderInput ref={ref}
                     inputClass={styles.input}
                     callback={onCallback}
                     name={name}
                     min={25}
                     max={100}
      />
    </div>
  );
});

class FJWatermarkCommonView extends Component {

  constructor(props) {
    super(props);

    this.sizeSlider = React.createRef();
    this.opacitySlider = React.createRef();
  }

  componentDidMount() {
    this._updateData();
  };

  componentDidUpdate() {
    this._updateData();
  }

  _updateData = () => {
    this.sizeSlider.current.updateSlider(Math.floor(this.props.watermarkSize));
    this.opacitySlider.current.updateSlider(Math.floor(this.props.watermarkOpacity));
  }

  _sizeChange = (data) => {
    this.props.setWatermarkParams && this.props.setWatermarkParams(FJActionConstant.UP_WATERMARK_SIZE, data)
  }

  _opacityChange = (data) => {
    this.props.setWatermarkParams && this.props.setWatermarkParams(FJActionConstant.UP_WATERMARK_OPACITY, data)
  }

  _positionChange = (position) => {
    this.props.setWatermarkParams && this.props.setWatermarkParams(FJActionConstant.UP_WATERMARK_POSITION, {value: position})
  }

  render() {

    let {
      watermarkPosition
    } = this.props;

    return (
      <>
        <SliderInput ref={this.sizeSlider}
                     name={FJLocalStore._('size')}
                     onCallback={this._sizeChange}/>
        <SliderInput ref={this.opacitySlider}
                     name={FJLocalStore._('opacity')}
                     onCallback={this._opacityChange}/>
        <div className={styles.position_box}>
          <div className={styles.position_label}>
            {FJLocalStore._('position')}
          </div>
          <PositionBtn watermarkPosition={watermarkPosition}
                       positionChange={this._positionChange}
          />
        </div>
      </>
    )
  }

}


export default FJWatermarkCommonView;
